exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "form input._2X7kDFXOqI8fbHGjjGwWfC{font-size:16px}div._3y5Zj092Y9AyHG23bp7V-Y{margin-bottom:20px;text-align:center}.fCREzByhfwwtwuW0EAotd{width:150px;margin:0px auto 20px auto;display:flex;justify-content:space-between}.fCREzByhfwwtwuW0EAotd ._2zXrsOzfrIR9rV-U1LS9bi>*{color:#3b5998}.fCREzByhfwwtwuW0EAotd>a,.fCREzByhfwwtwuW0EAotd>span{cursor:pointer}\n", ""]);

// Exports
exports.locals = {
	"largeText": "_2X7kDFXOqI8fbHGjjGwWfC",
	"logInWith": "_3y5Zj092Y9AyHG23bp7V-Y",
	"ssos": "fCREzByhfwwtwuW0EAotd",
	"fbBtn": "_2zXrsOzfrIR9rV-U1LS9bi"
};